import { useNavigate } from 'react-router-dom';
import { ACTION_TYPES, useCustomPageSearchDispatch } from './custom-page-search-context';
import CustomPageAppService from '../../../../application/platform/apm/custom-page/custom-page-app-service';
import { ICustomPagePagedResponse } from '../../../../model/apm/custom-page/response/custom-page-paged-response';
import { ICustomPagePagedRequest } from '../../../../model/apm/custom-page/request/custom-page-paged-request';
import { useActionRunner } from '../../../../hooks/use-action-runner';
import { useSearchActions } from '../../../../hooks/use-search-actions';
import { parseBooleanFilter } from '../../../../utils/filter-options';

export const useCustomPageSearchController = () => {
    const navigate = useNavigate();
    const dispatch = useCustomPageSearchDispatch();
    const { run, showSuccess, confirmDelete } = useActionRunner();
    const { updateParameters, triggerSearch, ...searchHandlers } = useSearchActions<ICustomPagePagedRequest>(
        dispatch, ACTION_TYPES, { term: undefined, isPublished: undefined },
    );

    function handleOnChange(e: any) {
        const { name, value } = e.target;
        if (name === 'input-term') updateParameters({ term: value || undefined });
        if (name === 'select-status') updateParameters({ isPublished: parseBooleanFilter(value) });
    }

    function handleDelete(row: ICustomPagePagedResponse) {
        confirmDelete(`Tem certeza que deseja excluir a página "${row.title}"?`, () => run('Não foi possível excluir a página', async () => {
            await CustomPageAppService.remove(row.id);
            showSuccess('Página excluída com sucesso!');
            triggerSearch();
        }));
    }

    function navigateToCreate() {
        navigate('/paginas/cadastrar');
    }

    function navigateToEdit(id: number) {
        navigate(`/paginas/editar/${id}`);
    }

    return { handleOnChange, ...searchHandlers, handleDelete, navigateToCreate, navigateToEdit };
};
